import { render } from "./app-cropper.vue?vue&type=template&id=07330f3e"
import script from "./app-cropper.vue?vue&type=script&lang=js"
export * from "./app-cropper.vue?vue&type=script&lang=js"

import "./app-cropper.vue?vue&type=style&index=0&id=07330f3e&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__